import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No results ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    dense: "",
    "use-input": "",
    "hide-selected": "",
    "fill-input": "",
    clearable: "",
    "clear-icon": _ctx.matClear,
    "model-value": _ctx.modelValue,
    label: "Channel",
    "input-debounce": "0",
    ref: "selectRef",
    behavior: "menu",
    loading: _ctx.loading,
    options: _ctx.channels,
    onFilter: _ctx.onFilter,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selected-value', $event)))
  }, {
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_q_item_section, {
                key: 0,
                class: "text-grey"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["clear-icon", "model-value", "loading", "options", "onFilter"]))
}